import DraggableTweetsColumns from 'app/components/DraggableTweetsColumns';
import Loader from 'app/components/Loader';
import { is } from 'immutable';
import AnalyedInfluencerCharts from 'influencers/components/AnalyedInfluencerCharts/AnalyedInfluencerCharts';
import TiktokAnalyzeChart from 'influencers/components/TiktokTabContent/TiktokAnalyzeChart';
import {
  getInstagramAnalyzedTab,
  getTwitterAnalyzedTab,
  loadLinkedInAnalyzeTab,
  loadTiktokAnalyzeTab,
  loadYoutubeAnalyzeTab,
} from 'influencers/Requests';
import {
  entitiesApiRoutes,
  influencerApiRoutes,
} from 'influencers/utils/apiRoutes';
import React, { FunctionComponent } from 'react';
import { useQuery } from 'react-query';
import { useReport } from 'reports/pages/AddNewReport/AddNewReport';
import { getDefaultInfluencersIds } from 'reports/Requests';
import { getTweetDetails } from 'tweets/Requests';
import { apiRoutes } from 'tweets/utils/apiRoutes';

interface Props {
  isTemplate?: boolean;
  items?: any[];
  reportInfluencer?: any;
  isInfluencer?: boolean;
  isEntity?: boolean;
  toDownloadId?: string;
  isReport?: boolean;
  reportData?: any;
}
const InfluencerSingle: FunctionComponent<Props> = ({
  isTemplate,
  items,
  reportInfluencer,
  isInfluencer,
  toDownloadId,
  isReport,
  reportData,
  isEntity,
}) => {
  const report = useReport();
  const {
    data: defaultInfluencersIds,
    isLoading: defaultInfluencersIdsLoading,
  } = useQuery('defaultInfluencersIds', getDefaultInfluencersIds, {
    enabled: !!isTemplate && !isReport,
  });

  const id =
    defaultInfluencersIds ||
    reportInfluencer?.id ||
    (toDownloadId ? +toDownloadId : false) ||
    +report?.values?.items?.[0]?.id;
  const checkIsTemplate = isTemplate && !isReport;

  const hasYoutube =
    (items?.filter((item: any) => item?.slug?.includes('youtube'))
      ?.length as number) > 0 ||
    (report?.values?.charts?.filter((item: any) =>
      item?.slug?.includes('youtube'),
    )?.length as number) > 0;

  const hasTwitter =
    (items?.filter((item: any) => item?.slug?.includes('twitter'))
      ?.length as number) > 0 ||
    (report?.values?.charts?.filter((item: any) =>
      item?.slug?.includes('twitter'),
    )?.length as number) > 0;
  const hasLinkedin =
    (items?.filter((item: any) => item?.slug?.includes('linkedin'))
      ?.length as number) > 0 ||
    (report?.values?.charts?.filter((item: any) =>
      item?.slug?.includes('linkedin'),
    )?.length as number) > 0;

  const hasInstagram =
    (items?.filter((item: any) => item?.slug?.includes('instagram'))
      ?.length as number) > 0 ||
    (report?.values?.charts?.filter((item: any) =>
      item?.slug?.includes('instagram'),
    )?.length as number) > 0;
  const hasTiktok =
    (items?.filter((item: any) => item?.slug?.includes('tiktok'))
      ?.length as number) > 0 ||
    (report?.values?.charts?.filter((item: any) =>
      item?.slug?.includes('tiktok'),
    )?.length as number) > 0;

  const hasTweets =
    (items?.filter((item: any) => item?.slug?.startsWith('tweets'))
      ?.length as number) > 0 ||
    (report?.values?.charts?.filter((item: any) =>
      item?.slug?.startsWith('tweets'),
    )?.length as number) > 0;

  const { data: youtubeData, isLoading: youtubeIsLoading } = useQuery(
    [
      'loadYoutubeAnalyzeTab',
      {
        influencer_id: checkIsTemplate ? id?.youtube : +id,
        isInfluencerModule: isInfluencer,
        is_sample: checkIsTemplate,
      },
    ],
    loadYoutubeAnalyzeTab,
    {
      staleTime: 0,
      refetchInterval: 0,
      cacheTime: 0,
      onError: (e) => console.log(e),
      enabled: !!id && hasYoutube,
    },
  );

  const { data: twitterData, isLoading: twitterIsLoading } = useQuery(
    [
      'getTwitterAnalyzedTab',
      {
        body: {
          influencer_id: checkIsTemplate ? id?.twitter : +id,
          is_sample: checkIsTemplate,
        },
        isInfluencerModule: isInfluencer,
      },
    ],
    getTwitterAnalyzedTab,
    { onError: (e) => console.log(e), enabled: !!id && hasTwitter },
  );

  const { data: linkedInData, isLoading } = useQuery(
    [
      'loadLinkedInAnalyzeTab',
      {
        influencer_id: id,
        isInfluencerModule: isInfluencer,
        is_sample: checkIsTemplate,
      },
    ],
    loadLinkedInAnalyzeTab,
    {
      onError: (e: any) => console.log(e),
      enabled: !!id && hasLinkedin,
      staleTime: 0,
      refetchInterval: 0,
      cacheTime: 0,
    },
  );
  const { data: instagramData, isLoading: instagramIsLoading } = useQuery(
    [
      'getInstagramAnalyzedTab',
      {
        isInfluencerModule: isInfluencer,
        body: {
          influencer_id: id,
          is_sample: checkIsTemplate,
        },
      },
    ],
    getInstagramAnalyzedTab,
    { onError: (e: any) => console.log(e), enabled: !!id && hasInstagram },
  );
  const { data: tiktokData, isLoading: tiktokIsLoading } = useQuery(
    [
      'loadTiktokAnalyzeTab',
      {
        influencer_id: id,
        isInfluencerModule: isInfluencer,
        is_sample: checkIsTemplate,
      },
    ],
    loadTiktokAnalyzeTab,
    { onError: (e: any) => console.log(e), enabled: !!id && hasTiktok },
  );

  const { data: tweetData, isLoading: isTweetLoading } = useQuery(
    [
      'getTweetAnalyzedTab',
      {
        body: {
          tweet_id: reportInfluencer?.id || toDownloadId,
          is_sample: checkIsTemplate,
        },
      },
    ],
    getTweetDetails,
    {
      enabled: hasTweets && !isInfluencer,
    },
  );
  if (
    (twitterIsLoading && hasTwitter) ||
    defaultInfluencersIdsLoading ||
    (youtubeIsLoading && hasYoutube) ||
    (instagramIsLoading && hasInstagram) ||
    (tiktokIsLoading && hasTiktok) ||
    (isTweetLoading && hasTweets) ||
    isLoading
  )
    return <Loader />;
  return (
    <>
      {hasTiktok ? (
        <TiktokAnalyzeChart
          {...{
            influencer_id: id,
            isInfluencerModule: isInfluencer,
            isEntity,
            isTemplate,
            tiktokData,
            isReport: isReport,
            is_full_grabbed: isTemplate,
          }}
          items={items}
        />
      ) : (
        <AnalyedInfluencerCharts
          {...{
            influencer_id: id,
            isInfluencerModule: isInfluencer,
            isEntity,
            youtubeData,
            twitterData,
            instagramData,
            isTemplate,
            tweetData,
            isReport: isReport,
            is_full_grabbed: isTemplate,
          }}
          linkedInData={linkedInData}
          items={items}
        />
      )}
      <DraggableTweetsColumns
        hideSort
        isReport
        isMultiTweets
        isTemplate={!!toDownloadId || isTemplate}
        items={items}
        isInfluencerModule={isInfluencer}
        infIds={id}
        reportState={report}
        linkInSlug={
          isInfluencer
            ? influencerApiRoutes().LinkedInPostsTabUpToDate
            : entitiesApiRoutes().LinkedInPostsTabUpToDate
        }
        instagramSlug={
          isInfluencer
            ? influencerApiRoutes().instagramPostsTab
            : entitiesApiRoutes().instagramPostsTab
        }
        tikTokSlug={
          isInfluencer
            ? influencerApiRoutes().tiktokPostsTab
            : entitiesApiRoutes().tiktokPostsTab
        }
        TweetsRepliesSlug={apiRoutes.tweetReplies}
        TweetsQuotesSlug={apiRoutes.tweetQuotes}
        filters={{
          start_date: reportData?.start_date,
          end_date: reportData?.end_date,
          is_sample: checkIsTemplate,
          tweet_id: hasTweets && !hasTwitter ? id : undefined,
        }}
        tabName={
          hasLinkedin
            ? 'POSTS'
            : hasInstagram
              ? 'POSTS_INSTA'
              : hasTiktok
                ? 'TIKTOK'
                : 'TWEETS'
        }
        tweetColumnFilters={undefined}
        customFilters={undefined}
        analyzed={false}
        action={function (arg: {
          body: any;
          isInfluencerModule?: boolean | undefined;
        }): Promise<unknown> {
          throw new Error('Function not implemented.');
        }}
        compId={''}
      />
    </>
  );
};

export default InfluencerSingle;
